import { useQuery } from '@tanstack/react-query';
import api from '@/lib/api';
import type { TodoWorkspaceSummary } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface UseTodoListWorkspaceSummaryReturn {
  summaries: TodoWorkspaceSummary[];
  loading: boolean;
}

/**
 * Visible-list counts across every workspace the caller can access
 * (Personal + active Org memberships). Used to tell the user when they
 * have lists in workspaces OTHER than the one currently selected, so a
 * Holder switch is never mistaken for data loss.
 */
export function useTodoListWorkspaceSummary(): UseTodoListWorkspaceSummaryReturn {
  const { data, isLoading } = useQuery({
    queryKey: queryKeys.todoLists.workspaceSummary(),
    queryFn: () => api.listTodoListWorkspaceSummary(),
  });

  return {
    summaries: data?.summaries ?? [],
    loading: isLoading,
  };
}
